import React from 'react';
import "./EnvBanner.css";

const EnvironmentBanner = () => {
    const env = process.env.REACT_APP_STAGE;

    let backgroundColor = '';
    let text = '';

    switch (env) {
        case 'hml': 
            backgroundColor = 'orange';
            text = 'Homologação';
            break;

        case 'local': 
            backgroundColor = 'red'; 
            text = 'Desenvolvimento / Local';
            break;

        default:
            return null;
    }

    return (
        <div className="md:text-base environment-banner" style={{ backgroundColor, color: 'white', textAlign: 'center', padding: '1px' }}>
            {text.toUpperCase()}
        </div>
    );
};

export default EnvironmentBanner;